import generateTimesheetPdf from './generateTimesheetPdf'
import { markTimesheetsPrinted, markInvoicesPrinted } from '../service/client'
import { OFFICE_USER } from '../constants/permissions.json'

export default function generateTimesheetsPdf(arr, user, invoices, invoiceIds) {
  return import('jspdf').then(jsPDF => {
    return import('jspdf-autotable').then(() => {
      const doc = jsPDF.jsPDF('portrait')

      arr.forEach((ts, i) => {
        const { data, vendor, shortNote, longNote, timesheetId, hasInvoice } = ts
        const invoiceData = invoices?.find(i => i.timesheetId === timesheetId)
        generateTimesheetPdf(data, vendor, timesheetId, shortNote, longNote, doc, i === arr.length - 1, invoiceData)
      })

      doc.autoPrint()
      doc.output('dataurlnewwindow')

      const timesheetIds = arr.map(a => a.timesheetId).join(', ')
      // if (user.permissions.includes(OFFICE_USER)) {
      if (user.username.toLowerCase() === 'admin') {
        return markTimesheetsPrinted(user, timesheetIds).then(r => {
          if (invoiceIds) {
            return markInvoicesPrinted(user, invoiceIds).then(() => {
              return r;
            })
          } else {
            return r;
          }
        }).catch(e => {
          console.log('markPrintedError', e)
        });
      } else {
        return Promise.resolve();
      }

    })
  })
}